<template>
  <div style="width: 100%;height: 240px;">
    <div class="banner2"
      style="height: 240px;margin: 0 auto;display: flex;align-items: center;justify-content: space-between;padding: 0 170px;box-sizing: border-box;">
      <div>
        <img src="../../assets/images/rhbsm.png" style="width: 117px;height: 23px;margin-bottom: 23px;">
        <div style="display: flex;justify-content: flex-start;">
          <div style="width: 28px;height: 28px;cursor: pointer;margin-right: 10px;" v-for="(item, index) in media"
            :key="index">

            <div class="weixin" style="display: flex;justify-content: flex-start;position: relative;">
              <img v-if="item.mediaType == 1" src="../../assets/images/wx@2x.png"
                style="width: 28px;height: 28px;cursor: pointer;">
              <img class="erweima" :src="baseURL + item.url"
                style="width: 100px;height: 100px;position: absolute;top: -105px;left: -35px;">
            </div>
            <div>
              <a v-if="item.mediaType == 2" :href="item.url"><img src="../../assets/images/wb@2x.png"
                  style="width: 28px;height: 28px;cursor: pointer;"></a>
            </div>
          </div>
          <!-- <div style="width: 28px;height: 28px;cursor: pointer;margin-right: 10px;">
            <img src="../../assets/images/wx@2x.png" style="width: 28px;height: 28px;cursor: pointer;">
          </div>

          <img src="../../assets/images/wb@2x.png" style="width: 28px;height: 28px;cursor: pointer;"> -->
        </div>
      </div>
      <div>
        <div
          style="font-size: 16px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 64px;">
          友情链接</div>
        <div>
          <span
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;margin-right: 40px;cursor: pointer;"
            v-if="linkList[0]"><a :href="linkList[0].linkUrl">{{linkList[0].linkName}}</a></span>
          <span
            style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;cursor: pointer;"
            v-if="linkList[1]"><a :href="linkList[1].linkUrl">{{linkList[1].linkName}}</a></span>
        </div>
        <div
          style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;color: #6C7480;line-height: 32px;cursor: pointer;"
          v-if="linkList[2]"><a :href="linkList[2].linkUrl">{{linkList[2].linkName}}</a></div>
      </div>
      <div>
        <div style="font-size: 16px;font-family: PingFang-SC-Medium, PingFang-SC;color: #1F2329;line-height: 64px;">
          联系我们</div>
        <div
          style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;line-height: 32px;color: #6C7480;">
          Tel：{{info.tel}}</div>
        <!-- <div
          style="font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;line-height: 32px;color: #6C7480;">
          公司地址：{{info.address}}</div> -->
      </div>
    </div>
	<div
	  style="width: 100%;height: 50px;background-color: #F2F4F6;text-align: center;font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #6C7480;line-height: 25px;padding: 10px 0;color: #2b90fc;">
	   <a href="https://beian.miit.gov.cn" style="color: #2b90fc;">备案号：{{info.websiteBa}}</a>
	</div>
    <!-- <div
      style="width: 100%;height: 50px;background-color: #F2F4F6;text-align: center;font-size: 12px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #6C7480;line-height: 25px;padding: 10px 0;">
      {{info.copyright}} <br /> {{info.websiteBa}}
    </div> -->
  </div>
</template>

<script>
  import {
    setHotArticles,
    getIndex,
    getArticle,
    getLinks,
    getInfo,
    getMedia,
    submit
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server'
  export default {
    data() {
      return {
        info: {},
        media: [],
        linkList: [],
        baseURL: '',
      }
    },
    mounted() {
      this.baseURL = serverUrl.baseURL
      this.setInfo()
      this.setMedia()
      this.setLinks()
    },
    methods: {
      setLinks() {
        getLinks().then(res => {
          this.linkList = res
        })
      },
      setInfo() {
        getInfo().then(res => {
          this.info = res
        })
      },
      setMedia() {
        getMedia().then(res => {
          this.media = res
        })
      },
    }
  }
</script>

<style scoped>
  @media (max-width: 1500px) {
    .banner2 {
      width: 1440px;
    }
  }

  @media (min-width: 1500px) {
    .banner2 {
      width: 1640px;
    }
  }

  a {
    color: #6C7480;
  }

  .erweima {
    display: none;
  }

  .weixin:hover .erweima {
    display: block !important;
  }

  .kf:hover {
    background: #F8FFFF;
    border-radius: 100px 100px 0px 0px;
  }

  .kf:hover .kfQr {
    display: block !important;
  }

  .dh:hover {
    background: #F8FFFF;
    border-radius: 0px 0px 100px 100px;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/bNavigation.vue